import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import { useState } from 'react'

import { placeJobBid } from 'api/jobs'
import { getFormattedDate } from '../../helpers/utils'
import { validateStringIsNumberAtMostTwoDecimal } from '../../helpers/validators'

export const JobBidModal = ({ record, bids, setBids, className = null, buttonColor = 'Primary' }: any) => {
  /* state */
  const [open, setOpen] = useState(false)

  const [bidAmount, setBidAmount] = useState('')
  const [bidAmountError, setBidAmountError] = useState('')
  const [bidNote, setBidNote] = useState('')

  const handleBidAmountChange = (event: any) => {
    // validation bid amount before setting it
    const rawBidAmount = event.target.value
    const errorMessage = validateStringIsNumberAtMostTwoDecimal(rawBidAmount)

    if (errorMessage) {
      setBidAmountError(errorMessage)
    } else {
      setBidAmount(rawBidAmount)
      setBidAmountError('')
    }
  }
  const handleBidNoteChange = (event: any) => {
    setBidNote(event.target.value)
  }

  const handleSubmit = () => {
    placeJobBid(record.id, bidAmount, bidNote).then((data) => {
      // put new bid in front of bids arr
      setBids([data, ...bids])
      setOpen(false)
    })
  }

  return (
    <div>
      <Button className={className} variant="text" color={buttonColor} onClick={() => setOpen(true)}>
        Place Bid / View History
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Record Bidding</DialogTitle>
        <DialogContent>
          <DialogContentText>Bidding History</DialogContentText>
          <ul>
            {bids.map((item: any, idx: any) => (
              <li key={idx}>
                ${item.amount}, {item.created_by.email} at {getFormattedDate(item.date_created)}
                <br></br>
                {item.notes}
              </li>
            ))}
          </ul>
        </DialogContent>
        <DialogContent>
          <FormControl fullWidth style={{ flexDirection: 'row' }}>
            <TextField
              id="bid_amount"
              label="Bid Amount"
              variant="outlined"
              fullWidth
              style={{ marginTop: '10px', width: '50%' }}
              required={true}
              onChange={handleBidAmountChange}
              error={bidAmountError !== ''}
              helperText={bidAmountError}
            />
            <div style={{ marginTop: '10px', marginLeft: '10px' }}>
              {record.user_submitted_bid_min && record.user_submitted_bid_max && (
                <Typography>
                  Customer's bid: ${record.user_submitted_bid_min} - ${record.user_submitted_bid_max}
                </Typography>
              )}
              {record.load.estimated_rate_min && record.load.estimated_rate_max && (
                <Typography>
                  CT Estimate: ${record.load.estimated_rate_min} - ${record.load.estimated_rate_max}
                </Typography>
              )}
            </div>
          </FormControl>
          <FormControl fullWidth>
            <TextField
              id="bid_note"
              label="Note (optional)"
              multiline
              fullWidth
              rows={4}
              placeholder="Note (optional)"
              variant="outlined"
              style={{ marginTop: '10px' }}
              required={false}
              onChange={handleBidNoteChange}
            />
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={handleSubmit} disabled={bidAmountError !== ''}>
            Place bid
          </Button>
          <Button color="secondary" onClick={() => setOpen(false)}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}
